import React, { useState, Suspense, lazy } from 'react';
import {
    useDispatch,
    useSelector
} from 'react-redux';
import {
    createStyles,
    ActionIcon,
    Button,
    Collapse,
    Select,
    TextInput,
    NumberInput,
    Switch,
    Radio,
    SegmentedControl,
    Card,
    Paper,
    Avatar,
    Group,
    TypographyStylesProvider,
    Text,
    Progress,
    Image,
    Stack
} from '@mantine/core';
import {
    DatePicker,
    DateRangePicker,
    TimeInput
} from '@mantine/dates';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';
import {
  IconUpload,
  IconX,
} from '@tabler/icons';


import { 
    carCreatorTextInfoUpdated,
    carCreatorSelectSectionDataB,
    fetchTests,
    testPost,
    testUpload,
    selectImage
} from '../features/auctionItemMgmt/auctionItemMgmtSlice';
import { 
    fieldInfoUpdated,
    selectSectionData,
} from '../features/home/homeSlice';
//descript:here for upload tests
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';
import pagani from '../assets/pagani.jpg';


const useStyles = createStyles((theme) => ({
    cardContain: {
        width: '80%',
        maxWidth: '800px',
        margin: '0 auto'
    },
    buttonContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        borderTop: `1px solid ${
            theme.colorScheme === 'dark' ? theme.colors.dark[5] : theme.colors.gray[2]
        }`,
    },
    buttonArea: {
        width: '49%',
        justifyContent: 'center',
    },
    buttonItem: {
        position: 'relative',
        left: '25%'
    },
    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
    
}));


//needed: pass params to fill out the areas of the alert item
//export function AlertItem {
const FileUploadItem = ({name, tot_sent, tot_size, img_preview}) => {
    const { classes } = useStyles();
    const dispatch = useDispatch();
    
    //of_note:may need to consider making child an dsection dynamic
    const component_md = {
        par: 'msgs',
        lvl: 0,
        child: 'all',
        section: 'all',
    }



    return (
        <>
            <Card
                withBorder
                radius="md"
                padding="xl"
                className={classes.cardContain}
                sx={(theme) => ({
                    backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
                })}
            >
                <Text fz="xs" tt="uppercase" fw={700} c="dimmed">
                    {name}
                </Text>
                <br/>
                <Image
                    src={img_preview}
                    radius={"md"}
                    width={100}
                    height={100}
                />
                <Text fz="lg" fw={500}>
                    {tot_sent} / {tot_size}
                </Text>
                <Progress value={33.31} mt="md" size="lg" radius="xl" />
                <br/>
                <Group position="apart">
                    <Stack justify="center" align="center">
                        <ActionIcon
                            title="Cancel"
                            color="red"
                        >
                            <IconX size="2.0em" />
                        </ActionIcon>
                        <Text ta="center">
                            Cancel
                        </Text>
                    </Stack>
                    <Stack justify="center" align="center">
                        <ActionIcon
                            title="Upload"
                            color="dark"
                        >
                            <IconUpload size="2.0em" />
                        </ActionIcon>
                        <Text ta="center">
                            Upload
                        </Text>
                    </Stack>
                </Group>
            </Card>
        </>
    );
    
}
export default FileUploadItem
